import React, { useContext } from 'react';

import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { RootStoreContext } from 'index';
import SideBar from 'components/common/SideBar/SideBar';
import Button from 'components/common/Button/Button';
import { ApplicationRoute } from 'routes/routes.enums';
import { hasPermission } from 'components/permissions/permissions.utils';
import { PermissionName } from 'components/permissions/permissions.enum';

import styles from './FeaturesRestricted.module.scss';
import FeaturesRestrictedText from './FeaturesRestrictedText';

const FeaturesRestricted = () => {
  const { intermediaryApplicationsStore, authStore, globalModalsStore } = useContext(RootStoreContext);
  const { mdaContacts } = intermediaryApplicationsStore;
  const { isFeatureRestrictedOpen, closeModal } = globalModalsStore;
  const canUpdateCompanyVerification = hasPermission(authStore.account!.permissions, [
    PermissionName.CompanyVerificationUpdate,
  ]);
  const navigator = useNavigate();

  const handleClose = () => {
    closeModal();

    if (canUpdateCompanyVerification) {
      navigator(ApplicationRoute.AccountStatus);
    } else {
      navigator(ApplicationRoute.MyProfile);
    }
  };

  return (
    <>
      <SideBar
        title="Features are restricted"
        isOpen={isFeatureRestrictedOpen}
        enableBackdropClick={false}
        onClose={handleClose}
      >
        <FeaturesRestrictedText mdaContacts={mdaContacts} />
        <Button className={styles.frameButton} onClick={handleClose} variant="white">
          Got It
        </Button>
      </SideBar>
    </>
  );
};

export default observer(FeaturesRestricted);
